import React, { useState } from 'react'
import { FaAnglesRight } from "react-icons/fa6";
import { Col, Row } from 'reactstrap';
import tshirt from '../../../assets/images/dummyImages/t-shirt-1.jpg'
import { MdVerified } from "react-icons/md";
import { formatLikes } from '../../../snippets/snippets';
import { NewsLetterStyle, ProdCardName } from '../../../StyledComponents';
import { AiOutlineLike } from "react-icons/ai";
import MaeStyleForm from './MaeStyleForm';
import { IoCaretBackOutline } from "react-icons/io5";

const MaeStyle = () => {

  const [showForm, setShowForm] = useState(false);

  const myGallery = [
    {
      id: 1,
      name: "Jenny Bee",
      image: tshirt,
      likes: '1000'
    },
    {
      id: 2,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 3,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 4,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 5,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 6,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 7,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
    {
      id: 8,
      name: "Jenny Bee",
      image: tshirt,
      likes: '10000'
    },
  ]

  const handleAdd = () => {
    setShowForm(false);
  };

  return (
    <>
      {showForm ? (
        <>
          <Row className='px-md-4 p-2'>
            <Col xl='1' lg='1' md='1' sm='12' xs='12'><NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => setShowForm(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle></Col>
            <Col xl='11' lg='11' md='11' sm='12' xs='12'>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <NewsLetterStyle style={{ fontWeight: '700' }}>Add to Mae Style</NewsLetterStyle>
              </div>
              <MaeStyleForm showState={handleAdd} onCancel={() => setShowForm(false)} />
            </Col>
          </Row>
        </>
      ) : (
        <div className='px-md-4 p-2'>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='p-2'>Mae Style</div>
            <button type='submit' className='btn' style={{ backgroundColor: '#41B8E4', color: 'white' }}
              onClick={() => {
                setShowForm(true);
              }}
            >
              Add <FaAnglesRight />
            </button>
          </div>
          <ProdCardName className='p-2'>My Gallery</ProdCardName>
          <div>
            <Row className='m-0'>
              {myGallery.map((product) => (
                <Col key={product.id} xl='2' lg='3' md='3' sm='6' xs='12' style={{ height: 'auto' }}>
                  <div className='my-2' style={{ display: 'flex', flexDirection: 'column', boxShadow: "0px 2px 30px 0px #00000012" }}>
                    <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.image} alt={product.name} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '5px' }}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <MdVerified color='#FBBD34' /> &ensp;
                        <ProdCardName>{product.name}</ProdCardName>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}><AiOutlineLike /> {formatLikes(product.likes)}</div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      )}
    </>
  )
}

export default MaeStyle
